'use client';

import { cn } from '@sharpr/ui';

interface ConfirmedLineupToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
  className?: string;
}

/**
 * MLB "Confirmed lineup" filter toggle. Rendered standalone (NOT inside a
 * FilterShell header) so it keeps a fixed position whether the Teams / Markets
 * filters are expanded or collapsed.
 */
export function ConfirmedLineupToggle({ value, onChange, className }: ConfirmedLineupToggleProps) {
  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      aria-pressed={value}
      title={value ? 'Showing only players whose lineup is confirmed' : 'Show all players'}
      className={cn(
        'inline-flex items-center gap-1 px-2 py-1 min-h-[26px] text-[11px] font-medium rounded-full border transition-colors',
        value
          ? 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/40 hover:bg-emerald-500/20'
          : 'bg-white dark:bg-bg-tertiary text-gray-600 dark:text-text-secondary border-gray-200 dark:border-border-primary hover:border-gray-400 dark:hover:border-border-interactive',
        className,
      )}
    >
      <span
        className={cn(
          'inline-block w-1.5 h-1.5 rounded-full',
          value ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-text-tertiary',
        )}
      />
      Confirmed lineup
    </button>
  );
}
